import { render, staticRenderFns } from "./GroupCreationView.vue?vue&type=template&id=a83ab3dc&scoped=true"
import script from "./GroupCreationView.vue?vue&type=script&lang=ts"
export * from "./GroupCreationView.vue?vue&type=script&lang=ts"
import style0 from "./GroupCreationView.vue?vue&type=style&index=0&id=a83ab3dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83ab3dc",
  null
  
)

export default component.exports